var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-info-square.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 1.5H2C1.86739 1.5 1.74021 1.55268 1.64645 1.64645C1.55268 1.74021 1.5 1.86739 1.5 2V10C1.5 10.1326 1.55268 10.2598 1.64645 10.3536C1.74021 10.4473 1.86739 10.5 2 10.5H10C10.1326 10.5 10.2598 10.4473 10.3536 10.3536C10.4473 10.2598 10.5 10.1326 10.5 10V2C10.5 1.86739 10.4473 1.74021 10.3536 1.64645C10.2598 1.55268 10.1326 1.5 10 1.5ZM9.5 9.5H2.5V2.5H9.5V9.5Z",
    fill: "#F88181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.5 3.5H6.5V4.5H5.5V3.5ZM5.5 5.5H6.5V8.5H5.5V5.5Z",
    fill: "#F88181"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b9104c9e6a468acea0dffe48f0e99c73.svg";
export { ForwardRef as ReactComponent };